module.exports = __webpack_public_path__ + "img/f26.29e6b566.jpg";